<template>
  <div>
    <vs-popup
      fullscreen
      :active.sync="showGallery"
      :title="$t('Upload')"
    >
      <template #default>
        <vs-row vs-justify="space-between" v-if="false && showGallery && gallery.length < 1">
          <vs-col vs-type="flex" vs-w="12" >
            <div class="w-full text-center p-5">
              <h3>{{ $t("NoDocuments") }}</h3>
            </div>
          </vs-col>
        </vs-row>

        <div v-show="showGallery" class="gallery" v-for="(file, idx) in gallery" :key="idx">
          <a
            :href="`#${file.file_name}`"
            :title="file.file_name"
            @click.prevent="gallerySelectedFile(file)"
          >
            <auth-image
              width="600"
              height="400"
              :alt="file.file_name"
              :path="file.path"
              v-if="file.file_type == 'image'"
            ></auth-image>
            <div class="files" v-else>
              <i class="fa" :class="fileIconList[file.file_type] ? fileIconList[file.file_type] : 'fa-file-o'" style="font-size: xx-large;"></i><br>
              <span class="ml-2 mt-1"> {{file.file_name}} </span>
            </div>
          </a>
        </div>


      </template>
    </vs-popup>

    <input
      ref="sendFile"
      type="file"
      v-validate="{
        required: true,
        size: 2048,
      }"
      class="hidden"
      name="file"
      id="sendFile"
      @change="selectedFile($event)"
    />

    <vs-prompt
      v-if="!showGallery"
      :title="$t('SendFile')"
      class="fileupload"
      @cancel="closePrompt()"
      @accept="sendingFile"
      :accept-text="$t('Send')"
      :cancel-text="$t('Cancel')"
      @close="closePrompt()"
      :active="prompt"
    >
      <form @submit.prevent.stop>
        <DropFileChat @selectedFile="selectedFile" :url.sync="preview" :directDrag="directDrag" :fileDetails="fileDetails"/>
        <vs-divider v-if="!directDrag">OR</vs-divider>
        <vs-row v-if="!directDrag" class="mt-2 mb-2" vs-w="12">
          <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <b-button
              variant="primary"
              @click.prevent="showGallery=true"
            >{{ $t("SelectFromMedia") }}</b-button>
          </vs-col>
        </vs-row>
        <b-form-input
          class="mt-2"
          v-model="message"
          :placeholder="$t('TypeYourMessage')"
          @keyup.enter="sendingFile"
        ></b-form-input>
      </form>
      <b-progress
        v-if="percentage !== 0"
        :value="percentage"
        variant="primary"
        class="mt-5"
        show-value
        animated
      ></b-progress>
    </vs-prompt>
  </div>
</template>

<script>

import { getMyFiles } from "@/api/chat";
import { getFile } from "@/api/staff";
import { urlToFile, getFileIconList} from "@/utils/helper";
import AuthImage from "@/components/auth/image";
import $ from "jquery";
import DropFileChat from "@/components/DropFileChat";

export default {
  emits: ['update:prompt', 'send'],
  props: {
    prompt: Boolean,
    percentage: Number,
    copyFile: Object,
  },
  data: () => ({
    showGallery: false,
    preview: null,
    file: null,
    message: "",
    gallery: [],
    directDrag: false,
    fileIconList: getFileIconList(),
    fileDetails: null
  }),
  computed: {
    me() {
      return this.$store.state.auth.currentUser;
    }
  },
  watch: {
    show(show) {
      if(!show)
        this.showGallery = show
    },
    copyFile: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (val, oldVal) {
        if(val != null) {
          console.log('this.previewFile', val);
          this.file = val.file;
          this.fileDetails = {
            file_name: this.file.name,
            file_type: this.file.name.substring(this.file.name.lastIndexOf(".")+1, this.file.name.length).toLowerCase()
          }
          this.preview = val.file.type.includes('image') ? URL.createObjectURL(val.file) : null;
          this.directDrag = val.directDrag;
        }
      }
    },
    prompt(val) {
      if(!val) {
        this.message = "";
        this.preview = null;
        this.fileDetails = null;
        this.directDrag = false;
      }
    }
  },
  methods: {
    closePrompt() {
      this.file = null;
      this.preview = null;
      this.fileDetails = null;
      this.showGallery = false;
      this.message = '';
      this.directDrag = false;
      this.$emit('update:prompt', false)
    },
    toggleUploadNew() {
      this.showGallery = false;
      this.$emit('update:show', false);
      this.$emit('update:prompt', true);
    },
    messageHandler(event) {
      const response = event.detail.data;
      const message = response.data;
      if (message && message.file) {
        this.gallery.unshift({ ...message.file });
      }
    },
    async getGalleryFiles() {
      const req = {
        search: null,
        paginate: false,
        sortBy: "id",
        sortDesc: true,
        display_as_folder: null,
        sender_id: this.me.staff_id,
        sender_role: 'staff',
        select: ["id", "file_name", "path", "mime", "activity"],
      };

      if(this.me.user_role == 'user') {
        req.sender_role = 'user';
        req.sender_id = this.me.id;
      }

      const res = await getMyFiles(req);
      console.log(res.data);
      if (res.data.status != "success") return;
      this.gallery = res.data.data;
    },
    async gallerySelectedFile(file) {
      const response = await getFile(file.path);
      let url = URL.createObjectURL(response.data);
      const realFile = await urlToFile(url, file.file_name, file.mime);
      this.file = realFile;
      this.fileDetails = {
        file_name: realFile.name,
        file_type: realFile.name.substring(realFile.name.lastIndexOf(".")+1, realFile.name.length).toLowerCase()
      }
      this.preview = realFile.type.includes('image') ? url : null;
      this.showGallery = false;
    },
    selectedFile(file) {
      this.$emit('update:show', false);
      this.$emit('update:prompt', true);
      this.file = file;
      this.fileDetails = {
        file_name: file.name,
        file_type: file.name.substring(file.name.lastIndexOf(".")+1, file.name.length).toLowerCase()
      }
      this.preview = file.type.includes('image') ? URL.createObjectURL(file) : null;
    },
    sendingFile() {
      $(".fileupload .vs-dialog-accept-button").prop("disabled", true);
      $(".fileupload input").prop("disabled", true);
      // this.uploadFileProgress = setInterval(() => {
      //   this.percentage = this.percentage + 5;
      //   if (this.percentage == 100) {
      //     clearInterval(this.uploadFileProgress);
      //   }
      // }, 10);
      this.$emit('send', {
        file: this.file,
        message: this.message
      });
    },
  },
  mounted() {
    this.getGalleryFiles();
    if(this.me.user_role == 'user')
      document.addEventListener("user-chat-message", this.messageHandler);
    else
      document.addEventListener("staff-chat-message", this.messageHandler);
  },
  beforeDestroy() {
    if(this.me.user_role == 'user')
      document.removeEventListener("user-chat-message", this.messageHandler);
    else
      document.removeEventListener("staff-chat-message", this.messageHandler);
  },
  components: {
    AuthImage,
    DropFileChat
  }
}

</script>

<style lang="scss" scoped>

.con-vs-dialog {
  :deep(.vs-component.vs-divider) .vs-divider-border.after.vs-divider-border-default {
    background: unset;
  }
}

.con-vs-popup {

  div.gallery {
    margin: 5px;
    border: 1px solid #ccc;
    float: left;
    width: 180px;
  }

  div.gallery:hover {
    border: 1px solid rgba(var(--vs-primary), 1);
  }

  div.gallery img {
    width: 178px;
    height: 156px;
    margin: 12px 0;
  }
  div.gallery .files{
    padding: 70px 0;
    text-align: center;
    height: 180px;
    color:black
  }
}
</style>
